angular.module('impactx.list').controller('PersistentListFilterPanelCtrl', [
    '$scope',
    'dataGen',
    'listConfig',
    'mdPanelRef',
    'ToastService',
    'TranslationService',
    'themeFactory',
    PersistentListFilterPanelCtrl]);

function PersistentListFilterPanelCtrl($scope, dataGen, listConfig, mdPanelRef, ToastService, TranslationService, themeFactory) {
    $scope.newFilterName = impactX.isDefined(listConfig, 'persistentListFilters.selected.filter.value');

    $scope.saveLabel = TranslationService.get('save');
    $scope.filterName = TranslationService.get('filterName');
    $scope.theme = themeFactory.getTheme();

    $scope.saveFilter = function () {
        dataGen.postAsForm({}, {name: $scope.newFilterName, listConfig: listConfig}, '/list/filter/save').then(function (data) {
            ToastService.openStandardToast(data.data.message);
            mdPanelRef && mdPanelRef.close("saved");
        })
    };
}